import { WebRtcTestHandler } from '../WebRtcTestHandler'
import { Test, testStates } from './Test'

export class NetworkTest implements Test {

  private rtcPeerConn: RTCPeerConnection | undefined
  private readonly timeoutThreshold = 50 * 1000
  private timeout: number | undefined

  public testState = testStates['not started']
  public readonly name = 'NetworkTest'

  constructor(
    private readonly rtcConfiguration: RTCConfiguration,
    public readonly testMethod: (candidate: RTCIceCandidate) => boolean, 
    private readonly handler: WebRtcTestHandler, 
    public readonly resultElement: HTMLLIElement,
    public readonly isCritical: boolean)
    { }

  public async startTest() {
    this.testState = testStates['running']
    try{
      this.rtcPeerConn = new RTCPeerConnection(this.rtcConfiguration)
    } catch{
      this.endTest(false, WebRtcTestHandler.errorMessages.COULD_NOT_CREATE_PEER_CONNECTION)
      return
    }

    this.rtcPeerConn.onicecandidate = (evt) => {
      if (!this.rtcPeerConn || this.rtcPeerConn.connectionState === 'closed') {
        return
      }
      let candidate = evt.candidate
      if (candidate === null) {
        this.endTest(false, WebRtcTestHandler.errorMessages.COULD_NOT_FIND_MATCHING_CANDIDATE)
      } else if (this.testMethod(candidate)) {
        this.endTest(true)
      }
    }

    this.rtcPeerConn.onicecandidateerror = (evt) => {
      console.log('Failed to gather ice Candidate')
    }

    try {
      // need to createdatachannel for Safari on iOS to trigger onicecandidate
      this.rtcPeerConn.createDataChannel(null)
    } catch{
      this.endTest(false, WebRtcTestHandler.errorMessages.COULD_NOT_CREATE_DATA_CHANNEL)
    }

    await this.establishConnection()

    this.timeout = setTimeout(this.endTest.bind(this,), this.timeoutThreshold, false, WebRtcTestHandler.errorMessages.TIMEOUT)
  }

  public endTest(successful: boolean, message?: string) {
    successful ? this.testState = testStates['succeded'] : this.testState = testStates['failed']

    message ? this.handler.displayResult(successful, this, message) : this.handler.displayResult(successful, this)

    this.rtcPeerConn?.close()

    clearTimeout(this.timeout)
  }

  private async establishConnection() {
    if (!(this.rtcPeerConn)) {
      this.endTest(false, WebRtcTestHandler.errorMessages.PEER_CONNECTION_NOT_FOUND)
      return
    }

    try {
      var offer = await this.rtcPeerConn.createOffer()
    } catch {
      this.endTest(false, WebRtcTestHandler.errorMessages.COULD_NOT_CREATE_OFFER)
      return
    }

    try {
      await this.rtcPeerConn.setLocalDescription(offer)
    } catch {
      this.endTest(false, WebRtcTestHandler.errorMessages.COULD_NOT_SET_OFFER_DESCRIPTION)
      return
    }
  }
}
